import axios from 'axios'

class JobsAPI {
  createJob = async params => {
    return axios.post('api/jobs', params)
  }

  getJobs = async params => {
    return axios.get(`api/jobs`, {
      params,
    })
  }

  getMyJobs = async params => {
    return axios.get(`api/jobs/my`, {
      params,
    })
  }
}

export const jobsAPI = new JobsAPI()
